import SwoogoService from "services/Swoogo";

const OPTION_PARAMS = { per_page: 50, sort_by: "name", sort_dir: "asc" };

const fetchEventOptions = async ({ search_query }) => {
  const { data } = await SwoogoService.listEvents({
    search: search_query,
    ...OPTION_PARAMS,
  });
  return data;
};

const fetchSessionOptions = async ({ search_query }) => {
  const { data } = await SwoogoService.listSessions({
    search: search_query,
    ...OPTION_PARAMS,
  });
  return data;
};

export const EVENT_FILTER = {
  key: "event_id",
  title: "Event",
  type: "select",
  queryFn: fetchEventOptions,
};

export const SESSION_FILTER = {
  key: "session_id",
  title: "Session",
  type: "select",
  queryFn: fetchSessionOptions,
};

// A table scoped to one record drops the filter for that record, because the
// scope already fixes its value.
export const omitScopedFilters = (filters, scope) =>
  scope ? filters.filter(({ key }) => !(key in scope)) : filters;
